import { Fragment } from 'react'
import { STATUS_COPY } from '@/lib/invoice-status-copy'
import type { InvoiceStatus } from '@/lib/invoice-types'
import { cn } from '@/lib/utils'

const STEPS = ['Concept', 'Approval', 'Approved', 'Verzonden', 'Betaald']

const STATUS_STEP: Record<InvoiceStatus, number> = {
  DRAFT: 0,
  PARKED: 0,
  PENDING_APPROVAL: 1,
  APPROVED: 2,
  SENT: 3,
  ESCALATED: 3,
  PAID: 4,
  WITHDRAWN: -1,
  WRITTEN_OFF: -1,
  VOIDED: -1,
  REPLACED: -1,
}

/**
 * Facturen die de normale route verlaten krijgen geen stappenbalk maar de reden
 * waarom ze eruit gestapt zijn.
 */
const OFF_PATH: InvoiceStatus[] = ['WITHDRAWN', 'WRITTEN_OFF', 'VOIDED', 'REPLACED']

export function LifecycleStepper({
  status,
  reason,
  className,
}: {
  status: InvoiceStatus
  reason?: string | null
  className?: string
}) {
  if (OFF_PATH.includes(status)) {
    return (
      <div className={className}>
        <p className="text-sm font-medium text-ink-soft">{STATUS_COPY[status].label}</p>
        {reason ? <p className="mt-0.5 text-xs text-ink-faint">{reason}</p> : null}
      </div>
    )
  }

  const current = STATUS_STEP[status]
  const escalated = status === 'ESCALATED'

  return (
    <div className={cn('flex items-start', className)}>
      {STEPS.map((label, index) => {
        const done = index < current
        const active = index === current
        const alarm = active && escalated
        return (
          <Fragment key={label}>
            {index > 0 ? (
              <span className={cn('mt-[4px] h-px flex-1', index <= current ? 'bg-accent-600' : 'bg-hairline')} />
            ) : null}
            <div className="flex flex-col items-center gap-1.5">
              <span
                className={cn(
                  'h-2.5 w-2.5 rounded-full',
                  done || active ? 'bg-accent-600' : 'bg-fill-3',
                  alarm && 'bg-status-overdue',
                  active && (alarm ? 'ring-4 ring-status-overdue/25' : 'ring-4 ring-accent-600/25'),
                )}
              />
              <span
                className={cn(
                  'text-[10px]',
                  active ? 'font-medium text-ink' : 'text-ink-faint',
                  alarm && 'text-status-overdue',
                )}
              >
                {alarm ? 'Geëscaleerd' : label}
              </span>
            </div>
          </Fragment>
        )
      })}
    </div>
  )
}
